var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEarnedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 17.0005C17.9326 17.0059 16.6925 17.0629 15.7777 17.6741C15.341 17.966 14.966 18.341 14.6741 18.7777C14 19.7866 14 21.1911 14 24C14 26.8089 14 28.2134 14.6741 29.2223C14.966 29.659 15.341 30.034 15.7777 30.3259C16.6925 30.9371 17.9326 30.9941 20.25 30.9995V26.9055C18.9561 26.5725 18 25.3979 18 24C18 22.6021 18.9561 21.4275 20.25 21.0945V17.0005Z",
    fill: "#141414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 31L26.25 31V17H21.75V31Z",
    fill: "#141414"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.75 17.0005V21.0945C29.0439 21.4275 30 22.6021 30 24C30 25.3979 29.0439 26.5725 27.75 26.9055V30.9995C30.0674 30.9941 31.3075 30.9371 32.2223 30.3259C32.659 30.034 33.034 29.659 33.3259 29.2223C34 28.2134 34 26.8089 34 24C34 21.1911 34 19.7866 33.3259 18.7777C33.034 18.341 32.659 17.966 32.2223 17.6741C31.3075 17.0629 30.0674 17.0059 27.75 17.0005Z",
    fill: "#141414"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnedicon);
export default __webpack_public_path__ + "static/media/Earnedicon.f87a67650336505e381a588ce4dcb748.svg";
export { ForwardRef as ReactComponent };